import React from "react";
import Hero from "../../components/Hero";
import Collection from "../../components/Collection";
import "./home.css";
import NewArrival from "../../components/NewArrival";
import HeroRow from "../../components/HeroRow";
import BrandSlider from "../../components/BrandSlider";
import { Helmet } from "react-helmet";

const Home = () => {
  return (
    <section className="Home">
      <Helmet>
        <title>Tecnoferta Shop</title>
        <meta name="description" content={"Las mejores ofertas en smartphones y wearables, portátiles, tablets y aparatos electrónicos de última generación para el hogar. Precios imbatibles y las marcas más reconocidas. Tecnología de última generación al mejor costo, con una experiencia de compra rápida y sencilla."} />
        <meta name="keywords" content={`Tecnoferta buy, online, tecnoferta comprar, en línea`} />
      </Helmet>

      <Hero />
      <HeroRow />
      {/* <Collection /> */}
      <BrandSlider />
      <NewArrival />
    </section>
  );
};

export default Home;
